
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.545","height":"22.343"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1025","opacity":".503"}},[_c('path',{attrs:{"data-name":"Path 1751","d":"M12.775 15.369H4.77a.688.688 0 000 1.375h8.005a.688.688 0 000-1.375zM12.108.243v.02c-.086 0-.441-.034-1.334-.02H2.768A2.71 2.71 0 00.1 2.993v16.5a2.71 2.71 0 002.668 2.75h12.009a2.71 2.71 0 002.668-2.75V5.743zm4 19.247a1.355 1.355 0 01-1.334 1.375H2.768a1.355 1.355 0 01-1.334-1.372V2.996a1.355 1.355 0 011.334-1.375h7.987c-.012 1.646.019 2.75.019 2.75a2.71 2.71 0 002.668 2.75h2.668v12.372zM13.442 5.743a1.355 1.355 0 01-1.334-1.375V1.621l4 4.124h-2.666zm-.667 5.5H4.77a.688.688 0 000 1.375h8.005a.688.688 0 000-1.375z","stroke":"#000","stroke-width":".2"}})])])
          )
        }
      }
    